export default function Preloader() {
    $(window).on("load", function() {
        setTimeout(function() {
            $("body").addClass("no-loader")
            $("#home").removeClass("d-none")
        }, 1e3)
    });
}